import {
  getRemoteConfig,
  getValue,
  fetchAndActivate,
  setCustomSignals,
} from "firebase/remote-config";
import { useEffect, useState } from "react";
import { useFirebaseApp } from "./useFirebaseApp";

export function useFirebaseRemoteConfig(options: {
  enabled: boolean;
  customSignals: any;
}) {
  const { app } = useFirebaseApp();
  const [initialized, setInitialized] = useState(false);

  // initialize the remote config sdk
  useEffect(() => {
    if (!app) return;
    if (!options.enabled) return;

    const _remoteconfig = getRemoteConfig(app);
    _remoteconfig.settings.minimumFetchIntervalMillis = 3600000;
    _remoteconfig.defaultConfig = {};

    setCustomSignals(_remoteconfig, options.customSignals)
      .then(() => {
        return fetchAndActivate(_remoteconfig);
      })
      .then(() => {
        setInitialized(true);
      });
  }, [app, options.enabled]);

  function _getValue(key: string): string {
    const _remoteconfig = getRemoteConfig(app);
    if (!_remoteconfig) return null;
    const value = getValue(_remoteconfig, key);
    return (value as any)._value as string;
  }

  return {
    initialized,
    getValue: _getValue,
  };
}
